export default __webpack_public_path__ + "static/media/banner1b.9258dd85.jpg";